const stats = [
  { value: '1,200+', label: '收录剧集' },
  { value: '860+', label: '演员资料' },
  { value: '3,500+', label: '剧情资讯' },
  { value: '每日更新', label: '内容节奏' },
];

export default function IntroSection() {
  return (
    <section className="w-full bg-background-100 border-y border-background-200">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <div>
            <span className="inline-flex items-center gap-2 text-xs font-medium text-primary-700 bg-primary-100 rounded-full px-3 py-1">
              <i className="ri-heart-3-line"></i> 关于韩剧
            </span>
            <h2 className="mt-4 font-heading font-bold text-2xl md:text-4xl text-foreground-950 leading-snug">
              为韩剧爱好者打造的
              <br className="hidden md:block" />
              专业追剧与资讯平台
            </h2>
            <p className="mt-5 text-sm md:text-base text-foreground-600 leading-relaxed">
              「韩剧」聚焦最新韩国电视剧的内容展示与信息服务。我们提供分类浏览、剧集详情、剧情介绍、演员资料与热点资讯，
              帮助你在第一时间找到想看的剧、想追的人、想读的故事。网站仅提供浏览与资讯服务，不涉及任何播放与下载功能。
            </p>
            <div className="mt-6 flex flex-wrap gap-x-6 gap-y-3 text-sm text-foreground-700">
              <span className="flex items-center gap-2"><i className="ri-check-line text-primary-500"></i> 多条件筛选与排序</span>
              <span className="flex items-center gap-2"><i className="ri-check-line text-primary-500"></i> 剧情分集与演员关联</span>
              <span className="flex items-center gap-2"><i className="ri-check-line text-primary-500"></i> 收藏追剧本地保存</span>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4">
            {stats.map((s, i) => (
              <div
                key={s.label}
                className={`rounded-lg p-6 border ${
                  i === 0
                    ? 'bg-primary-500 border-primary-500 text-white'
                    : i === 1
                      ? 'bg-accent-100 border-accent-200 text-accent-900'
                      : 'bg-background-50 border-background-200 text-foreground-900'
                }`}
              >
                <p className="font-heading font-bold text-2xl md:text-3xl">{s.value}</p>
                <p className={`mt-1 text-sm ${i === 0 ? 'text-white/85' : 'text-foreground-500'}`}>{s.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}